<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-20 10:27:47
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-29 09:59:52
 * @FilePath: /wemeet-admin-new/src/views/channel/components/channelDetailByUser.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <vab-query-form class="ml-10">
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="form" @submit.prevent>
          <el-form-item label="姓名">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.phone" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" />
          </el-form-item>
          <el-form-item>
            <el-button style="margin-left: 10px" type="primary" @click="handleQueryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <div class="containerForm">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="手机号">
          <template #default="{ row }">{{ row.phoneCountryCode }} {{ row.phone }}</template>
        </el-table-column>
        <el-table-column label="机构" prop="company" />
        <el-table-column label="职位" prop="position" />
        <!-- <el-table-column label="报名状态">
          <template #default="{ row }">
            {{ filterSelectStatus[row.attendStatus] }}
          </template>
        </el-table-column>

        <el-table-column label="报名时间">
          <template #default="{ row }">
            {{row.attendTime ? row.attendTime : '/'}}
          </template>
        </el-table-column> -->

        <el-table-column label="导入时间">
          <template #default="{ row }">
            {{ row.createTime ? row.createTime : '/' }}
          </template>
        </el-table-column>

        <el-table-column label="备注">
          <template #default="{ row }">
            <el-input v-if="row.showEdit" v-model="row.remark" @blur="saveRemark(row)" />
            <template v-else style="cursor: pointer">
              {{ row.remark ? row.remark : '暂无备注' }}
              <Edit style="width: 1em; height: 1em; margin-right: 8px" @click="row.showEdit = true" />
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="form.pageNum"
        :layout="layout"
        :page-size="form.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <!-- <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div> -->
  </el-drawer>
  <!-- <el-dialog v-model="visible" title="提示">
    <p>因我方运营需求，需要生成并导出用户信息。导出的用户信息仅用于运营用途，我方承诺不会泄露用户隐私。如有泄露或造成纠纷，我方会承担相应法律责任。</p>
    <el-checkbox v-model="isCheck" label="请勾选确认" size="large" />
    <template #footer>
      <el-button type="primary" @click="handleExport(checkRow, 'N')"> 导出脱敏信息</el-button>
      <el-button type="primary" @click="handleExport(checkRow, 'Y')"> 导出完整信息</el-button>
    </template>
  </el-dialog> -->
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { _importChannelQuery, _importChannelUpdateRemark } from '@/api/channel'
  import { Delete, Plus, Search, Edit } from '@element-plus/icons'
  export default defineComponent({
    name: 'EditConfigDrawer',

    setup(props, { emit }) {
      /**
       * @description: cover主k 自定义校验
       * @return {*}
       */

      const { proxy } = getCurrentInstance()
      const state = reactive({
        form: {
          pageNum: 1,
          pageSize: 10,
          phone: '',
          code: '',
        },
        channelId: '',
        filterSelectStatus: {
          CANCEL_SIGN: '自主取消',
          ACCEPT: '通过',
          REFUSE: '拒绝',
          PENDING_REVIEW: '审核中',
          NOT_REVIEW: '通过',
        },
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        pararms: {
          type: 'MEETING_REGISTER_REPORT',
        },
        title: '查看数据',
        tableData: [],
        isCheck: false,
        visible: false,
        checkRow: {},
        total: 0,
        list: [],
        layout: 'prev, pager, next',

        // exportLoading: false,
      })

      // 打开
      const handleOpen = async (row = {}) => {
        state.channelId = row.id
        state.form.code = row.channelNo
        state.form = Object.assign(state.form, {})
        state.dialogFormVisible = true
        getData()
      }

      const getData = async () => {
        const { data } = await _importChannelQuery(state.form)
        console.log(data)
        state.tableData = data.list
        state.total = data.total
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const exportFile = (row) => {
        window.open(row.exportParams.fileUrl)
      }
      const handleDate = (val) => {
        return parseTime(val)
      }

      // 查询
      const handleQueryData = () => {
        state.form.pageNum = 1
        getData()
      }
      // 条数
      const handleSizeChange = (pageSize) => {
        state.form.pageSize = pageSize
        getData()
      }

      const handleCurrentChange = (pageNum) => {
        state.form.pageNum = pageNum
        getData()
      }
      const saveRemark = async (row) => {
        console.log(row)
        try {
          let data = {
            uid: row.uid,
            remark: row.remark,
            channelId: state.channelId,
          }
          await _importChannelUpdateRemark(data)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          getData()
        } catch (e) {
          console.log(e)
        }
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        exportFile,
        handleDate,
        handleQueryData,
        handleSizeChange,
        handleCurrentChange,
        Edit,
        saveRemark,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
